import * as CSS from 'csstype';


export const inputs: CSS.Properties = { 
    backgroundColor: 'transparent',
    width: '18rem',
    alignSelf: 'center',
    marginBottom: '1rem',
    marginTop: '.5rem',  
}

export const formContainer: CSS.Properties = { 
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',

}

export const button: CSS.Properties = { 
    backgroundColor: "#45CB85",
  
}

export const errorMessageStyles: CSS.Properties = { 
    color: 'red',
    textAlign: 'center',
    marginBottom: '2rem',
    fontSize: '.9rem',
}